"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
exports.Image = react_1.forwardRef(function Img(props, ref) {
    return jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "img", ref: ref, width: props.htmlWidth, height: props.htmlHeight }, props), void 0);
});
//# sourceMappingURL=index.js.map